import React from "react";
import ManAndLadyImg from "./ManAndLady.png";
import Pattern from "./Pattern.png";
import styles from "./HomeIdeas.module.scss";

export const HomeIdeas = () => {
  return (
    <section className={styles.ideas}>
      <div>
        {/* text part  */}
        <p>Struggling with your idea?</p>
        <h4>Our process can help you move forward</h4>
        <img src={Pattern} alt="Dots" />
      </div>
      <div>
        {/* img part  */}
        <img
          src={ManAndLadyImg}
          alt="A man and a lady looking at a computer screen"
        />
      </div>
    </section>
  );
};
